import { useState, useEffect } from "react";
import * as api from "../api/client";

type ProfilesAccess = {
  enabled: boolean;
  permitted: boolean;
};

type FeaturesAccess = {
  profiles: ProfilesAccess;
};

const DEFAULT_FEATURES: FeaturesAccess = {
  profiles: { enabled: false, permitted: false },
};

type AccessResponse = {
  features: FeaturesAccess;
  request_id: string;
};

export type { FeaturesAccess, ProfilesAccess };

export function useAccess() {
  const [features, setFeatures] = useState<FeaturesAccess>(DEFAULT_FEATURES);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    api
      .get<AccessResponse>("/v1/me/access")
      .then(data => {
        if (!cancelled) {
          setFeatures(data.features ?? DEFAULT_FEATURES);
          setError(null);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error("Failed to fetch access flags"));
          setFeatures(DEFAULT_FEATURES);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { features, isLoading, error };
}
